import { Card, Col, Container, Row, Spinner } from "react-bootstrap";
import {
  faAddressCard,
  faCarBurst,
  faMagnifyingGlass,
  faPersonRunning,
  faTableList,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainContext } from "../App";
import React, { useState, useEffect } from "react";
import apiService from "../api";
import { useLocation } from "react-router-dom";

export const CustomerVehicleDetailPart = (props) => {
  const typeMapping = {
    muayene: "Muayene belgesi",
    ruhsat: "Ruhsat",
    koltukSigortasi: "Koltuk sigorta belgesi",
    trafikSigortasi: "Trafik sigorta belgesi",
    riskAnalysis: "Risk analizi",
    emergencyEvacuationPlan: "Acil eylem kaçış planı",
  };

  const iconMapping = {
    muayene: faMagnifyingGlass,
    ruhsat: faAddressCard,
    koltukSigortasi: faUsers,
    trafikSigortasi: faCarBurst,
    riskAnalysis: faTableList,
    emergencyEvacuationPlan: faPersonRunning,
  };

  const { accessToken, setProgress } = React.useContext(MainContext);
  const [vehicleData, setVehicleData] = useState(null);
  const [loading, setLoading] = useState(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const vehicleId = queryParams.get("vehicleId");
  const plate = queryParams.get("plate");
  const sasToken = localStorage.getItem('sasToken');

  useEffect(() => {
    if (!accessToken || !vehicleId) return;

    setLoading(true);
    apiService.get(`customer/vehicle/${vehicleId}/files`, accessToken, setProgress)
      .then(response => {
        if (response.success && response.data) {
          setVehicleData(response.data);
        }
      })
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [accessToken, vehicleId, setProgress]);

  const files = vehicleData?.files || {};
  const anyVehicleDoc = Object.keys(files).some((key) => key in typeMapping && files[key]);

  const generateVehicleDocs = () => {
    return Object.keys(files).map((key) => {
      if (key in typeMapping && files[key]) {
        return (
          <Col
            key={key}
            style={{ marginTop: 10 }}
            xs={4}
            onClick={(e) =>
              window.open(
                files[key] + sasToken,
                typeMapping[key],
                "width:550px;height:550px"
              )
            }
          >
            <Card style={{
              cursor: "pointer",
              padding: 3,
              background: "rgba(20, 52, 92, 0.05)",
              border: "2px solid rgba(20, 52, 92, 0.3)",
              borderRadius: "10px",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-5px)";
              e.currentTarget.style.boxShadow = "0 8px 30px rgba(20, 52, 92, 0.5)";
              e.currentTarget.style.borderColor = "rgba(20, 52, 92, 0.6)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.borderColor = "rgba(20, 52, 92, 0.3)";
            }}>
              <Card.Body>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "150px",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <div>
                    <FontAwesomeIcon
                      color="#5a9bd4"
                      size="2x"
                      icon={iconMapping[key]}
                    ></FontAwesomeIcon>
                  </div>
                  <span style={{
                    fontWeight: 600,
                    fontSize: "18px",
                    color: "#5a9bd4",
                    marginTop: "10px"
                  }}>
                    {typeMapping[key]}
                  </span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
      }
      return null;
    });
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%)",
      padding: "20px"
    }}>
      <Container>
        <Card style={{
          marginTop: 10,
          width: "100%",
          background: "#000000",
          border: "2px solid rgba(20, 52, 92, 0.4)",
          borderRadius: "15px",
          boxShadow: "0 8px 40px 0 rgba(20, 52, 92, 0.3)"
        }}>
          <Card.Body>
            <Card.Title style={{
              textAlign: "center",
              color: "#5a9bd4",
              textShadow: "0 0 10px rgba(20, 52, 92, 0.5)",
              fontWeight: "700",
              fontSize: "24px"
            }}>
              Araç evrakları - {vehicleData?.plate || plate || "(-)"}
            </Card.Title>
            {loading ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <Spinner animation="border" style={{ color: "#5a9bd4" }} />
              </div>
            ) : anyVehicleDoc ? (
              <Row>{generateVehicleDocs()}</Row>
            ) : (
              <Card.Text style={{ color: "#fff", textAlign: "center", marginTop: "20px" }}>
                <u>Araca ait evrak bulunamadı.</u>
              </Card.Text>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};
